<template>
  <div>
    <TextField
      v-if="showCustomInput"
      v-model="_value"
      class="w-full"
    />
    <SelectField
      v-else
      v-model="_value"
      :options="options"
      class="w-full"
    />
    <div class="mt-1 flex justify-end">
      <a
        class="ml-auto text-sm text-primary-500"
        @click="toggleCustomInput"
      >
        {{ showCustomInput ? 'Select from list' : 'Enter custom title' }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TextField, SelectField } from '@/components/fields'

interface Props {
  modelValue?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: '',
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const showCustomInput = ref(false)
const model = ref('')
const options = [
  'Mr',
  'Mrs',
  'Ms',
  'Dr',
  'Prof',
  'Rev',
  'Sir',
  'Lady',
  'Lord',
  'Dame',
  'Mx',
]

const _value = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

const toggleCustomInput = () => {
  showCustomInput.value = !showCustomInput.value

  if (showCustomInput.value) {
    _value.value = ''
  }
}
</script>
